import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="powered-by-section">
          <h3 className="powered-by-title">Powered by AI Researchers from</h3>
          <div className="institution-logos">
            <div className="institution-logo-container">
              <img src="/images/cmu.png" alt="Carnegie Mellon University" className="institution-logo" />
            </div>
          </div>
        </div>
        <div className="copyright-section">
          <p>© 2025 XLR8 AI. All rights reserved.</p>
          <p className="location">Built in San Francisco</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 